export const SHORTCUT_ACTIONS = {
  HISTORY_UNDO: "history.undo",
  HISTORY_REDO: "history.redo",
  PROJECT_NEW: "project.new",
  PROJECT_UPLOAD_FILES: "project.uploadFiles",
  PROJECT_SAVE_ENVIRONMENT: "project.saveEnvironment",
  PHYSICS_PLAY_PAUSE: "physics.playPause",
  INSPECTOR_RENAME: "inspector.rename",
  INSPECTOR_COPY_SELECTION: "inspector.copySelection",
  INSPECTOR_PASTE_DUPLICATE: "inspector.pasteDuplicate",
  INSPECTOR_DUPLICATE: "inspector.duplicate",
  SCENE_CONTEXT_MENU_OPEN: "scene.contextMenu.open",
  GIZMO_POSITION_TOGGLE: "gizmo.position.toggle",
  GIZMO_ROTATION_TOGGLE: "gizmo.rotation.toggle",
  GIZMO_CYCLE: "gizmo.cycle",
  GIZMO_EXIT: "gizmo.exit",
  VIEWER_LAYER_TOGGLE_VISUAL: "viewer.layer.toggleVisual",
  VIEWER_LAYER_TOGGLE_COLLISION: "viewer.layer.toggleCollision",
  VIEWER_LAYER_TOGGLE_JOINTS: "viewer.layer.toggleJoints",
  VIEWER_LAYER_TOGGLE_SITES: "viewer.layer.toggleSites",
  VIEWER_LAYER_TOGGLE_INERTIALS: "viewer.layer.toggleInertials",
  VIEWER_LAYER_TOGGLE_CONSTRAINT_MARKERS: "viewer.layer.toggleConstraintMarkers",
  VIEWER_LAYER_TOGGLE_TENDON_MARKERS: "viewer.layer.toggleTendonMarkers",
  VIEWER_LAYER_TOGGLE_ACTUATORS: "viewer.layer.toggleActuators",
  VIEWER_PRIORITY_BODY: "viewer.priority.body",
  VIEWER_PRIORITY_OBJECT: "viewer.priority.object",
  VIEWER_PRIORITY_JOINT: "viewer.priority.joint",
  VIEWER_PRIORITY_VISUALS: "viewer.priority.visuals",
  VIEWER_PRIORITY_COLLISION: "viewer.priority.collision",
  VIEWER_PRIORITY_SITE: "viewer.priority.site",
  VIEWER_PRIORITY_INERTIAL: "viewer.priority.inertial",
  VIEWER_PRIORITY_CONSTRAINT: "viewer.priority.constraint",
  VIEWER_PRIORITY_TENDON: "viewer.priority.tendon",
  VIEWER_CAMERA_VIEW_TOP: "viewer.camera.top",
  VIEWER_CAMERA_VIEW_BOTTOM: "viewer.camera.bottom",
  VIEWER_CAMERA_VIEW_FRONT: "viewer.camera.front",
  VIEWER_CAMERA_VIEW_BACK: "viewer.camera.back",
  VIEWER_CAMERA_VIEW_LEFT: "viewer.camera.left",
  VIEWER_CAMERA_VIEW_RIGHT: "viewer.camera.right",
  VIEWER_CAMERA_RESET: "viewer.camera.reset",
  VIEWER_CAMERA_FOCUS_SELECTION: "viewer.camera.focusSelection",
  VIEWER_CAMERA_FIT_SCENE: "viewer.camera.fitScene",
  PANEL_TOGGLE_SCENE_GRAPH: "panel.sceneGraph.toggle",
  PANEL_TOGGLE_ASSET_LIBRARY: "panel.assetLibrary.toggle",
  PANEL_TOGGLE_KEYBOARD_SHORTCUTS: "panel.keyboardShortcuts.toggle",
};

export const DEFAULT_SHORTCUT_BINDINGS = {
  [SHORTCUT_ACTIONS.HISTORY_UNDO]: ["mod+z"],
  [SHORTCUT_ACTIONS.HISTORY_REDO]: ["mod+shift+z", "ctrl+y"],
  [SHORTCUT_ACTIONS.PROJECT_NEW]: ["mod+alt+n"],
  [SHORTCUT_ACTIONS.PROJECT_UPLOAD_FILES]: ["mod+o"],
  [SHORTCUT_ACTIONS.PROJECT_SAVE_ENVIRONMENT]: ["mod+s"],
  [SHORTCUT_ACTIONS.PHYSICS_PLAY_PAUSE]: ["space"],
  [SHORTCUT_ACTIONS.INSPECTOR_RENAME]: ["f2"],
  [SHORTCUT_ACTIONS.INSPECTOR_COPY_SELECTION]: ["mod+c"],
  [SHORTCUT_ACTIONS.INSPECTOR_PASTE_DUPLICATE]: ["mod+v"],
  [SHORTCUT_ACTIONS.INSPECTOR_DUPLICATE]: ["mod+d"],
  [SHORTCUT_ACTIONS.SCENE_CONTEXT_MENU_OPEN]: ["shift+f10", "contextmenu"],
  [SHORTCUT_ACTIONS.GIZMO_POSITION_TOGGLE]: ["t"],
  [SHORTCUT_ACTIONS.GIZMO_ROTATION_TOGGLE]: ["r"],
  [SHORTCUT_ACTIONS.GIZMO_CYCLE]: ["q"],
  [SHORTCUT_ACTIONS.GIZMO_EXIT]: ["escape"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_VISUAL]: ["v"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_COLLISION]: ["c"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_JOINTS]: ["j"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_SITES]: ["s"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_INERTIALS]: ["i"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_CONSTRAINT_MARKERS]: ["e"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_TENDON_MARKERS]: ["n"],
  [SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_ACTUATORS]: ["a"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_BODY]: ["shift+b"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_OBJECT]: ["shift+o"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_JOINT]: ["shift+j"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_VISUALS]: ["shift+v"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_COLLISION]: ["shift+c"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_SITE]: ["shift+s"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_INERTIAL]: ["shift+i"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_CONSTRAINT]: ["shift+e"],
  [SHORTCUT_ACTIONS.VIEWER_PRIORITY_TENDON]: ["shift+n"],
  /* Numpad alternates (no Ctrl+): 8↑ top, 2↓ bottom, 4← 6→, 1 front 3 back; 7 home, 5 fit all, Enter focus selection */
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_TOP]: ["mod+alt+t", "numpad8"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_BOTTOM]: ["mod+alt+shift+t", "numpad2"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_FRONT]: ["mod+alt+f", "numpad1"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_BACK]: ["mod+alt+k", "numpad3"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_LEFT]: ["mod+alt+l", "numpad4"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_RIGHT]: ["mod+alt+r", "numpad6"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_RESET]: ["mod+alt+h", "numpad7"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_FOCUS_SELECTION]: ["shift+f", "numpadenter"],
  [SHORTCUT_ACTIONS.VIEWER_CAMERA_FIT_SCENE]: ["mod+alt+a", "numpad5"],
  [SHORTCUT_ACTIONS.PANEL_TOGGLE_SCENE_GRAPH]: ["g"],
  [SHORTCUT_ACTIONS.PANEL_TOGGLE_ASSET_LIBRARY]: ["l"],
  [SHORTCUT_ACTIONS.PANEL_TOGGLE_KEYBOARD_SHORTCUTS]: ["shift+?"],
};

export const SHORTCUT_DISPLAY_GROUPS = [
  {
    title: "Project",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.PROJECT_NEW, label: "New Project" },
      { actionId: SHORTCUT_ACTIONS.PROJECT_UPLOAD_FILES, label: "Upload Files" },
      { actionId: SHORTCUT_ACTIONS.PROJECT_SAVE_ENVIRONMENT, label: "Save Project" },
    ],
  },
  {
    title: "History",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.HISTORY_UNDO, label: "Undo" },
      { actionId: SHORTCUT_ACTIONS.HISTORY_REDO, label: "Redo" },
    ],
  },
  {
    title: "Physics",
    shortcuts: [{ actionId: SHORTCUT_ACTIONS.PHYSICS_PLAY_PAUSE, label: "Play / Pause" }],
  },
  {
    title: "Inspector",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.INSPECTOR_RENAME, label: "Rename Selection" },
      { actionId: SHORTCUT_ACTIONS.INSPECTOR_COPY_SELECTION, label: "Copy Selection" },
      { actionId: SHORTCUT_ACTIONS.INSPECTOR_PASTE_DUPLICATE, label: "Paste Duplicate" },
      { actionId: SHORTCUT_ACTIONS.INSPECTOR_DUPLICATE, label: "Duplicate Selection" },
    ],
  },
  {
    title: "Scene",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.SCENE_CONTEXT_MENU_OPEN, label: "Open Viewport Context Menu" },
      { actionId: SHORTCUT_ACTIONS.PANEL_TOGGLE_SCENE_GRAPH, label: "Toggle Scene Graph" },
      { actionId: SHORTCUT_ACTIONS.PANEL_TOGGLE_ASSET_LIBRARY, label: "Toggle Library" },
      {
        actionId: SHORTCUT_ACTIONS.PANEL_TOGGLE_KEYBOARD_SHORTCUTS,
        label: "Keyboard Shortcuts",
      },
    ],
  },
  {
    title: "Transform",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.GIZMO_POSITION_TOGGLE, label: "Toggle Position Gizmo" },
      { actionId: SHORTCUT_ACTIONS.GIZMO_ROTATION_TOGGLE, label: "Toggle Rotation Gizmo" },
      { actionId: SHORTCUT_ACTIONS.GIZMO_CYCLE, label: "Cycle Gizmo" },
      { actionId: SHORTCUT_ACTIONS.GIZMO_EXIT, label: "Exit Gizmo" },
    ],
  },
  {
    title: "Camera",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_TOP, label: "Top View" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_BOTTOM, label: "Bottom View" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_FRONT, label: "Front View" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_BACK, label: "Back View" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_LEFT, label: "Left View" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_VIEW_RIGHT, label: "Right View" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_RESET, label: "Reset Camera View" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_FOCUS_SELECTION, label: "Focus Selection" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_CAMERA_FIT_SCENE, label: "Fit Entire Scene" },
    ],
  },
  {
    title: "Viewport Visibility",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_VISUAL, label: "Toggle Visuals" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_COLLISION, label: "Toggle Collisions" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_JOINTS, label: "Toggle Joints" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_SITES, label: "Toggle Sites" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_INERTIALS, label: "Toggle Inertials" },
      {
        actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_CONSTRAINT_MARKERS,
        label: "Toggle Constraints",
      },
      {
        actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_TENDON_MARKERS,
        label: "Toggle Tendons",
      },
      {
        actionId: SHORTCUT_ACTIONS.VIEWER_LAYER_TOGGLE_ACTUATORS,
        label: "Toggle Actuators",
      },
    ],
  },
  {
    title: "Selection Priority",
    shortcuts: [
      { actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_BODY, label: "Prioritize Bodies" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_OBJECT, label: "Prioritize Objects" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_JOINT, label: "Prioritize Joints" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_VISUALS, label: "Prioritize Visuals" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_COLLISION, label: "Prioritize Collisions" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_SITE, label: "Prioritize Sites" },
      { actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_INERTIAL, label: "Prioritize Inertials" },
      {
        actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_CONSTRAINT,
        label: "Prioritize Constraints",
      },
      {
        actionId: SHORTCUT_ACTIONS.VIEWER_PRIORITY_TENDON,
        label: "Prioritize Tendons",
      },
    ],
  },
];

const SHORTCUT_TOKEN_LABELS = {
  mod: "Ctrl/Cmd",
  ctrl: "Ctrl",
  meta: "Cmd",
  alt: "Alt",
  shift: "Shift",
  space: "Space",
  escape: "Esc",
  contextmenu: "Menu",
};

function formatKeyTokenForShortcutDisplay(token) {
  if (token === "numpaddecimal") return "Num .";
  if (token === "numpadenter") return "Num Enter";
  const numpadDigit = /^numpad([0-9])$/.exec(token);
  if (numpadDigit) return `Num ${numpadDigit[1]}`;
  if (token.length === 1) return token.toUpperCase();
  return token.charAt(0).toUpperCase() + token.slice(1);
}

export function formatShortcutCombo(combo) {
  return String(combo || "")
    .split("+")
    .map((token) => token.trim().toLowerCase())
    .filter(Boolean)
    .map((token) => {
      if (SHORTCUT_TOKEN_LABELS[token]) return SHORTCUT_TOKEN_LABELS[token];
      return formatKeyTokenForShortcutDisplay(token);
    })
    .join("+");
}

export function formatPrimaryShortcutForAction(actionId, bindings = DEFAULT_SHORTCUT_BINDINGS) {
  const [primaryCombo] = bindings[actionId] || [];
  return primaryCombo ? formatShortcutCombo(primaryCombo) : "";
}

export function withShortcutLabel(label, actionId, bindings = DEFAULT_SHORTCUT_BINDINGS) {
  const shortcut = formatPrimaryShortcutForAction(actionId, bindings);
  return shortcut ? `${label} (${shortcut})` : label;
}

export function getShortcutDisplayGroups(bindings = DEFAULT_SHORTCUT_BINDINGS) {
  return SHORTCUT_DISPLAY_GROUPS.map((group) => ({
    ...group,
    shortcuts: group.shortcuts
      .map((shortcut) => ({
        ...shortcut,
        combos: bindings[shortcut.actionId] || [],
      }))
      .filter((shortcut) => shortcut.combos.length > 0),
  })).filter((group) => group.shortcuts.length > 0);
}
